import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { QueryClientProvider } from "@tanstack/react-query";
import { MantineProvider } from "@mantine/core";

import "@mantine/core/styles.css";

import { routeTree } from "@/routeTree.gen";
import { queryClient } from "@/lib/queryClient";
import { brandCssVariables, theme } from "@/theme";
import { AccessPending } from "@/features/auth/components/AccessStatus";

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPendingComponent: AccessPending,
  defaultPreload: "intent",
});

// Gives useNavigate/Link full type inference over the generated route tree.
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root is missing from index.html.");
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <MantineProvider theme={theme} cssVariablesResolver={brandCssVariables} defaultColorScheme="auto">
        <RouterProvider router={router} />
      </MantineProvider>
    </QueryClientProvider>
  </StrictMode>,
);
